module.exports = __webpack_public_path__ + "static/media/inovativabrasil.e366b3f0.svg";